export const isThousandOperand = (currency: string): boolean => {
  return ['JOD', 'OMR', 'KWD', 'BHD', 'IQD', 'LYD', 'TND'].includes(currency);
};

export const formatAmountWithCommas = ({
  amount,
  keepDecimals = true,
  currency,
  excludeZeroDecimals = false
}: {
  amount: number;
  keepDecimals?: boolean;
  currency?: string;
  excludeZeroDecimals?: boolean;
}) => {
  const isInteger = Number.isInteger(Number(amount));

  const shouldExcludeZeroDecimals = excludeZeroDecimals && isInteger;

  let decimal;

  if (!keepDecimals) {
    decimal = 0;
  } else if (shouldExcludeZeroDecimals) {
    decimal = 0;
  } else if (currency && isThousandOperand(currency)) {
    decimal = 3;
  } else {
    decimal = 2;
  }
  return amount?.toFixed(decimal)?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const convertCentsToMajorUnit = (amount: number, currency: string, round?: boolean) => {
  const multipliedAmount = isThousandOperand(currency) ?
    (amount / 1000)
    :
    (amount / 100);

  return round ? Math.round(multipliedAmount) : multipliedAmount;
};

export const getLocalizedCurrency = (lang: 'en' | 'ar', currency: string) => {
  const localizedCurrency = {
    en: {
      "EGP": "EGP",
      "USD": "USD",
      "AED": "\uFAA4",
      "OMR": "\uFAA6",
      "SAR": "\uFAA5",
      "PKR": "PKR",
      "BHD": "BHD",
      "KWD": "KWD",
      "IQD": "IQD",
      "LYD": "LYD",
      "TND": "TND",

      "EUR": "EUR",
      "GBP": "GBP",
      "CAD": "CAD",
      "INR": "INR",
      "PHP": "PHP",
      "TWD": "TWD",
      "BRL": "BRL",
      "MAD": "MAD",
      "ZAR": "ZAR",
      "MXN": "MXN",
      "MYR": "MYR",
    },
    ar: {
      "EGP": "جنية مصرى",
      "USD": "دولار امريكى",
      "AED": "\uFAA4",
      "OMR": "\uFAA6",
      "SAR": "\uFAA5",
      "PKR": "روبيه باكستاني",
      "BHD": "دينار بحريني",
      "KWD": "دينار كويتي",
      "IQD": "دينار عراقي",
      "LYD": "دينار ليبي",
      "TND": "دينار تونسي",

      "EUR": "يورو",
      "GBP": "جنيه إسترليني",
      "CAD": "دولار كندي",
      "INR": "روبيه هندي",
      "PHP": "بيزو فلبيني",
      "TWD": "دولار تايواني",
      "BRL": "ريال برازيلي",
      "MAD": "درهم مغربي",
      "ZAR": "راند جنوب أفريقي",
      "MXN": "بيزو مكسيكي",
      "MYR": "رينجيت ماليزي"
    }
  };

  return localizedCurrency[lang][currency as keyof typeof localizedCurrency.en] || currency;
};